import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Loader from '../../../../../../../../../components/shared/custom-components/Loader';
import ExchangeImport from '../../../../../../../../../components/source-management/exchanges/exchange-page/exchange-import/ExchangeImport';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/imports',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: ExchangeImport,
  staticData: {
    isClientRoute: true,
  },
});
